import $ from 'jquery';
import carouselPrev from '../assets/Image-Carousel-Prev.svg';
import carouselNext from '../assets/Image-Carousel-Next.svg';

export const imageGallery = () => {
  const $gallery = $('.image-gallery');

  $('.image-gallery__images').slick({
    dots: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: '.image-gallery__thumbnails',
    respondTo: 'slider',
    prevArrow: `<figure class="prev"><img class='slider-arrow prev' src='${carouselPrev}' /></figure>`,
    nextArrow: `<figure class="next"><img class='slider-arrow next' src='${carouselNext}' /></figure>`,
  });

  $('.image-gallery__thumbnails').slick({
    dots: false,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.image-gallery__images',
    focusOnSelect: true,

    respondTo: 'slider',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Remove active class from all thumbnail slides
  $('.image-gallery__thumbnails  .slick-slide').removeClass('slick-active');

  // Set active class to first thumbnail slides
  $('.image-gallery__thumbnails .slick-slide').eq(0).addClass('slick-active');

  // On before slide change match active thumbnail to current slide
  $('.image-gallery__images').on(
    'beforeChange',
    function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      $('.image-gallery__thumbnails .slick-slide').removeClass('slick-active');
      $('.image-gallery__thumbnails .slick-slide')
        .eq(mySlideNumber)
        .addClass('slick-active');
    }
  );

  const replaceSVG = (arrows) => {
    arrows.each(function () {
      var $img = $(this);
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(
        imgURL,
        function (data) {
          var $svg = $(data).find('svg');

          if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
          }

          $svg = $svg.removeAttr('xmlns:a');

          $img.replaceWith($svg);
        },
        'xml'
      );
    });
  };

  $gallery.each(function () {
    const $arrows = $(this).find('.slider-arrow');
    replaceSVG($arrows);
  });
};
